import React, { useEffect } from 'react';
import { FaBrain } from 'react-icons/fa';

import { QuestsModel } from '../../../../../../Models/Quests/Quests.Model';
import { IoChevronDownSharp, IoChevronUpSharp } from 'react-icons/io5';


import "./BrainsDropdown.scss";

import { SwivlNavigateFunction } from '../../../../../../Models/NavBar/useSwivlNavigate';
import { QuestInterface } from '@swivl-mono/types';
import { Spinner, Dropdown } from '@swivl-mono/ui';
import { BrainsModel } from '../../../../../../Models/Brains/Brains.Model';



interface Props {
  selectedQuest: QuestInterface;
  navigate: SwivlNavigateFunction
  canEdit: boolean
}
export default function BrainsDropdown(props: Props) {
  const [isEditing, setIsEditing] = React.useState(false);
  const { brains } = BrainsModel.useState(s => s)
  const { selectedQuest,canEdit } = props

  useEffect(() => {
    if (!canEdit && !brains) {
      BrainsModel.load(false)
    }
  }, [canEdit])

  let options:any;
  if (isEditing && brains) {
    options = brains.map(i => {
      return { value: i.slug, label: i.name }
    })
    options.unshift({ value: undefined, label: "Not Set" })
  }
  const optionSelectedMethod = (option:any) => {
    
    if (option.value === undefined) {
      selectedQuest.brainSlug = ""
    } else {
      selectedQuest.brainSlug = option.value
    }
     QuestsModel.updateQuest(selectedQuest, true)
  }


  if (!canEdit) {
  
    let brain = brains && brains.find(i => i.slug === selectedQuest.brainSlug) 
    

    return <div className="BrainsDropdown open">
      <div className="brainsDropdownHeader" >
        Brain
      </div>
      <div className="brainsDropdownContent">
        <div className="brainsLevel global"><FaBrain className="questBrain" /><span className="brainLevelTitle" >{brains ? brain?.name || "Not Set" : <Spinner />}</span></div>
      </div>
    </div>;
  }

  return <div className={isEditing ? "BrainsDropdown open" : "BrainsDropdown closed"}>
    <div className="brainsDropdownHeader" onClick={() => {
      setIsEditing(!isEditing)
      if (!brains) {
        BrainsModel.load(false)
      }
    }
    }>
      Brain {isEditing ? <IoChevronUpSharp /> : <IoChevronDownSharp />}
    </div>
    {isEditing ? <div className="brainsDropdownContent">
      {brains ? <Dropdown 
      options={options} 
      value={selectedQuest.brainSlug}
       name={"brainSlug"} 
       optionSelected={optionSelectedMethod}
       showSearch={true} 
       stayAtTopOnOpen={true} /> : <Spinner />}

    </div> : null
    }
  </div>;
}




// export class BrainsDropdownOld extends React.Component<Props, any>  {
//   constructor(props) {
//     super(props)
//     this.state = { isShowing: false }
//     this.onChange = this.onChange.bind(this)
//     this.toggleOpen = this.toggleOpen.bind(this)

//     this.questBrainClicked = this.questBrainClicked.bind(this)
//     this.journeyBrainClicked = this.journeyBrainClicked.bind(this)
//     this.globalBrainClicked = this.globalBrainClicked.bind(this)
//   }

//   onChange(e) {
//     const target = e.target;
//     var quest = this.props.selectedQuest;
//     quest.name = target.value;
//     QuestsModel.updateQuest(quest)
//   }

//   questBrainClicked() {
//     const category = this.props.selectedQuest.type === QuestType.ROUTER ? "Router" : "Quest";
//     this.props.navigate("/brains/" + this.props.selectedQuest.brainSlug)
//     AnalyticsEvent(category, "Quest Brain Clicked");

//   }
//   journeyBrainClicked() {
//     //TODO: fix this

//     // const category = this.props.selectedQuest.get("isRouter") ? "Router" : "Quest";

//     // AnalyticsEvent(category, "Journey Brain Clicked" );

//     // this.props.navigate("/brains/"+this.props.selectedQuest.get("newJourney").get("brain").id)
//   }
//   globalBrainClicked() {
//     //TODO: fix this
//     // const category = this.props.selectedQuest.get("isRouter") ? "Router" : "Quest";
//     // AnalyticsEvent(category, "Global Brain Clicked" );

//     // this.props.navigate("/brains/"+this.props.bot.get("brain").id)
//   }

//   toggleOpen() {
//     if (this.state.isShowing) {
//       AnalyticsEvent("Editor", "Brain Dropdown Close")
//     } else {
//       AnalyticsEvent("Editor", "Brain Dropdown Open")
//     }

//     this.setState({ isShowing: !this.state.isShowing })
//   }
//   render() {

//     if (!this.props.selectedQuest) { return null; }

//     if (this.props.selectedQuest.type === QuestType.ROUTER || !SubscriptionModel.showBrainTiers()) {
//       return <div className="BrainsDropdown open">
//         <div className="brainsDropdownHeader" >
//           Brain
//         </div>
//         <div className="brainsDropdownContent">
//           <div className="brainsLevel global"><FaBrain className="questBrain" /><span className="brainLevelTitle" onClick={this.globalBrainClicked}>Global</span></div>
//         </div>
//       </div>;
//     } else {
//       var content;

//       if (this.state.isShowing) {
//         /* TODO: fix this
//        content =         <div className="brainsDropdownContent">
//                   <div className="brainsLevel quest"><FaBrain className={this.props.selectedQuest.get("useQuestBrain") ? "brainOn" : "brainOff"} /><span className="brainLevelTitle" onClick={this.questBrainClicked}>This Quest</span><SSSwitch on={this.props.selectedQuest.get("useQuestBrain")} onChange={this.onChange} name="useQuestBrain" analytics={{category:"Editor", onAction:"Quest Brain On", offAction:"Quest Brain Off"}} /></div>
//                   <div className="downArrow"><BsArrowDownShort/></div>
//                   <div className="brainsLevel journey"><FaBrain className={this.props.selectedQuest.get("useJourneyBrain") ? "brainOn" : "brainOff"} /><span className="brainLevelTitle" onClick={this.journeyBrainClicked}>This Journey</span><SSSwitch on={this.props.selectedQuest.get("useJourneyBrain")} onChange={this.onChange} name="useJourneyBrain" analytics={{category:"Editor", onAction:"Journey Brain On", offAction:"Journey Brain Off"}} /></div>
//                   <div className="downArrow"><BsArrowDownShort/></div>
//                   <div className="brainsLevel global"><FaBrain className="questBrain" /><span className="brainLevelTitle" onClick={this.globalBrainClicked}>Global</span></div>
//               </div>                */

//       }
//       return <div className={this.state.isShowing ? "BrainsDropdown open" : "BrainsDropdown closed"}>
//         <div className="brainsDropdownHeader" onClick={this.toggleOpen}>
//           Brains {this.state.isShowing ? <IoChevronUpSharp /> : <IoChevronDownSharp />}
//         </div>
//         {this.state.isShowing ? <div className="brainsDropdownContent">
//           {this.props.selectedQuest.brainSlug}
//         </div> : <div className="brainsDropdownContent">
//           {this.props.selectedQuest.brainSlug}

//         </div>
//         }
//         {content}
//       </div>;


//     }


//   }
// }
